import React, { useState, useEffect } from "react";
import bankImage from "../../assets/img/tx/yes-bank.gif";
import cibilImage from "../../assets/img/tx/cibil_bank.png";
import InputRangeSlider from "../InputRangeSlider";
import useThrotlle from "../../hooks/useThrotlle";
import { useDispatch } from "../../redux/store";
import { loanBankOffers } from "../../redux/slices/loan";

const CheckAllBanksOffer = () => {
  const [loanAmt, setLoanAmt] = useState("");

  const [tenure, setTenure] = useState("");
  const throtlleLoan = useThrotlle(loanAmt, 5000);
  const throtlleTenure = useThrotlle(tenure, 5000);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loanBankOffers({ loanAmount: loanAmt, tenure: tenure }));
  }, [throtlleLoan, throtlleTenure]);
  let roughData = [
    {
      eligibleLoan: "300000",
      requestedLoan: "565656",
      bankImage: bankImage,
      bankName: "ICICI",
      interest_rate: "20%",
      processing_fees: "5%",
      emi: "4545",
      payment_charges: "2%",
    },
    {
      eligibleLoan: "20000",
      bankName: "axis",
      requestedLoan: "5656",
      bankImage: bankImage,
      interest_rate: "20%",
      processing_fees: "5%",
      emi: "4545",
      payment_charges: "2%",
    },
    {
      eligibleLoan: "400000",
      bankName: "Kotak",
      requestedLoan: "665656",
      bankImage: bankImage,
      interest_rate: "10%",
      processing_fees: "6%",
      emi: "45455",
      payment_charges: "4%",
    },
    {
      eligibleLoan: "700000",
      requestedLoan: "765656",
      bankName: "canara",
      bankImage: bankImage,
      interest_rate: "15%",
      processing_fees: "2%",
      emi: "45452",
      payment_charges: "2%",
    },
    {
      eligibleLoan: "800000",
      requestedLoan: "995656",
      bankName: "Bank of Maharashtra",
      bankImage: bankImage,
      interest_rate: "20%",
      processing_fees: "5%",
      emi: "4545",
      payment_charges: "2%",
    },
    {
      eligibleLoan: "900000",
      requestedLoan: "965656",
      bankName: "SBI",
      bankImage: bankImage,
      interest_rate: "7%",
      processing_fees: "8%",
      emi: "1145",
      payment_charges: "6%",
    },
  ];

  return (
    <>
      <div className="col-lg-12">
        <div className="card card_titleone mb-3">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-6 loan_amt_slider">
                <p>
                  Eligible Loan Amount: Rs. <span>100</span> lacs
                </p>
                <p>
                  Requested Loan Amount: Rs. <span>{loanAmt}</span> lacs
                </p>
                <InputRangeSlider
                  id="loan_amount"
                  minValue={10000}
                  maxValue={500000}
                  value={loanAmt}
                  setRangeValue={setLoanAmt}
                  //   className={`form-range ${
                  //     errors?.loan_amount ? "is-invalid" : ""
                  //   }`}
                />
                <div className="d-flex justify-content-between">
                  <p>Min: Rs. 0 lacs</p>
                  <p>Max: Rs. 100 lacs</p>
                </div>
              </div>
              <div className="col-lg-6 loan_amt_slider">
                <p>
                  Tenure: <span>{tenure} years</span>
                </p>
                <p>Select Tenure</p>
                <InputRangeSlider
                  id="loan_amount"
                  minValue={0}
                  maxValue={5}
                  step={0.5}
                  value={tenure}
                  setRangeValue={setTenure}
                  //   className={`form-range ${
                  //     errors?.loan_amount ? "is-invalid" : ""
                  //   }`}
                />
                <div className="d-flex justify-content-between">
                  <p>Min: = 1 years</p>
                  <p>Max: 5 years</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="card card_titleone mb-3">
          <div className="card-title mb-0">
            <h4>Offers are sorted by Chances of Approval</h4>
          </div>
        </div>
      </div>

      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
        {roughData &&
          roughData
            .filter((field) => field.requestedLoan < loanAmt)
            .map((field, index) => {
              return (
                <div className="card" key={index}>
                  <div className="card-body mt-4">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="bankoff_card d-flex">
                          <img src={bankImage} alt="" width={100} />
                          <div className="ms-3">
                            <h4 className="fs-20">{field?.bankName}</h4>
                            <p>Loan Amount:{field?.requestedLoan}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="bank_select_dc">
                          <ul>
                            <li>
                              <img src={roughData?.bankImage} alt="" />
                              <p>Fair</p>
                            </li>
                            <li>
                              <a href="#" className="btn btn-primary me-2">
                                Get Offer
                              </a>
                              <a
                                href="#"
                                className="btn btn-outline-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#ChatModal"
                              >
                                <i className="fas fa-comment-dots"></i> Chat
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-12 mt-2">
                        <div className="features">
                          <ul>
                            <li>
                              <span>Interest Rate:</span> {field?.interest_rate}
                            </li>
                            <li>
                              <span>Processing fees:</span>{" "}
                              {field?.processing_fees}
                            </li>
                            <li>
                              <span>EMI:</span> {field?.emi}
                            </li>
                            <li>
                              <span>Prepayment charges:</span> <br /> 1-12
                              Month- 5%, 13-24 Months- 4%, 25-36 Months- 3%,
                              &gt;37 Months- 2%--{field?.payment_charges}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    </>
  );
};
export default CheckAllBanksOffer;
